import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import RaisinsImg from '../assets/banners/raisins.jpg';
import { FaSun, FaGlobe, FaLeaf, FaBolt } from 'react-icons/fa';

const Raisins = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [email, setEmail] = useState('');

    const handleEnquiry = () => {
        const subject = encodeURIComponent("Raisin Order Enquiry");
        const body = encodeURIComponent(
            `Hi,\n\nI am interested in placing an order or getting a quotation for your raisins.\n\nPlease contact me back at: ${email}\n\nThanks,\n`
        );
        window.location.href = `mailto:yourmail@example.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-yellow-100 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl md:text-5xl font-bold text-yellow-700 mb-4">Premium Raisins</h1>
                <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
                    Sun-dried, naturally sweet raisins — perfect for healthy snacking, baking, cooking & global distribution.
                </p>
            </section>

            {/* Image and Details Section */}
            <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10 items-center">
                <div data-aos="zoom-in">
                    <img
                        src={RaisinsImg}
                        alt="Raisins"
                        className="rounded-xl shadow-xl"
                    />
                </div>
                <div data-aos="fade-left">
                    <h2 className="text-3xl font-semibold text-yellow-700 mb-6">Why Choose Our Raisins?</h2>
                    <ul className="space-y-4 text-gray-700">
                        <li className="flex items-start gap-3"><FaSun className="text-yellow-600 mt-1" />Sun-dried with zero additives or preservatives</li>
                        <li className="flex items-start gap-3"><FaLeaf className="text-yellow-600 mt-1" />Naturally sweet & fiber-rich for healthy digestion</li>
                        <li className="flex items-start gap-3"><FaBolt className="text-yellow-600 mt-1" />High-energy snack for kids & adults</li>
                        <li className="flex items-start gap-3"><FaGlobe className="text-yellow-600 mt-1" />Available in bulk for export, wholesale & retail</li>
                        <li className="flex items-start gap-3"><FaSun className="text-yellow-600 mt-1" />Types: Golden, Green, Black & Munakka</li>
                    </ul>
                </div>
            </section>

            {/* Specifications Section */}
            <section className="bg-yellow-50 py-14 px-4" data-aos="fade-up">
                <div className="max-w-5xl mx-auto">
                    <h3 className="text-3xl font-bold text-yellow-700 text-center mb-10">Product Specifications</h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <table className="w-full text-sm border border-yellow-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-yellow-200">
                                    <th className="p-4 text-left bg-yellow-100">Types</th>
                                    <td className="p-4">Golden, Black, Green, Brown, Munakka</td>
                                </tr>
                                <tr className="border-b border-yellow-200">
                                    <th className="p-4 bg-yellow-100">Origin</th>
                                    <td className="p-4">India (Sangli, Solapur, Nashik)</td>
                                </tr>
                                <tr className="border-b border-yellow-200">
                                    <th className="p-4 bg-yellow-100">Shelf Life</th>
                                    <td className="p-4">9–12 months</td>
                                </tr>
                                <tr className="border-b border-yellow-200">
                                    <th className="p-4 bg-yellow-100">Packaging</th>
                                    <td className="p-4">250g, 500g, 5kg, 10kg Box / Vacuum Packs</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-yellow-100">Moisture</th>
                                    <td className="p-4">Below 15%</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="w-full text-sm border border-yellow-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-yellow-200">
                                    <th className="p-4 text-left bg-yellow-100">Nutritional Value (per 100g)</th>
                                    <td className="p-4">
                                        Calories: 299 kcal<br />
                                        Protein: 3g<br />
                                        Fat: 0.5g<br />
                                        Carbs: 79g<br />
                                        Fiber: 3.7g
                                    </td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-yellow-100">Usage</th>
                                    <td className="p-4">
                                        Trail Mix, Baking, Cooking, Sweets, Energy Bars, Gifting Packs
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Quality & Logistics Icons Section */}
            <section className="max-w-6xl mx-auto py-16 px-4 grid md:grid-cols-4 gap-6 text-center" data-aos="fade-up">
                <div>
                    <FaSun className="text-4xl mx-auto text-yellow-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Sun-Dried</h4>
                </div>
                <div>
                    <FaLeaf className="text-4xl mx-auto text-yellow-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">No Preservatives</h4>
                </div>
                <div>
                    <FaBolt className="text-4xl mx-auto text-yellow-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Energy Booster</h4>
                </div>
                <div>
                    <FaGlobe className="text-4xl mx-auto text-yellow-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Global Exports</h4>
                </div>
            </section>

            {/* Enquiry Section */}
            <section className="bg-yellow-100 py-10 px-4" data-aos="fade-up">
                <div className="max-w-xl mx-auto text-center">
                    <h3 className="text-2xl font-bold text-yellow-800 mb-4">Send Us an Enquiry</h3>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email Address"
                        className="w-full p-3 rounded border border-yellow-300 mb-4 focus:outline-none"
                    />
                    <button
                        onClick={handleEnquiry}
                        className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-2 rounded-lg transition-all"
                    >
                        Send Enquiry
                    </button>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Raisins;
